import React from 'react';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import Select from '../../../form/Select';
import ShiftsForm from '../ShiftsForm';
import facilityInfoIcon from '../../../../assets/images/facility-info-icon.svg';

const SECTION_INFO_TEXT = 'Request up to 30 dates total with up to 20 professionals per shift.';

const facilityNameFilter = (option, input) => {
	if (!input) return true;
	return option.label.toLowerCase().includes(input.toLowerCase());
};

const OnCallInfoBanner = () => (
	<div className="on-call-info-banner">
		<img className="tooltip-title" src={facilityInfoIcon} alt="info" />
		<span>On Call shifts are only available for On Demand shifts at this time.</span>
	</div>
);

const GlobalCalendarFacilitySelector = ({ facilities, selectedFacility, handleSelectFacility }) => (
	<div>
		<div className="section-header">Facility</div>
		<div className="select-facility-container">
			<div className="facility-label">
				Facility
				<OverlayTrigger
					className="tooltip-component"
					placement="right"
					delay={{ show: 100, hide: 400 }}
					overlay={
						<Tooltip delay={{ show: 150, hide: 400 }} className="info-facility-tooltip">
							This list will only include facilities where you have permission to request shifts. If the facility you
							need isn’t listed, please reach out to your account manager.
						</Tooltip>
					}
				>
					<img src={facilityInfoIcon} alt="info" />
				</OverlayTrigger>
			</div>
			<div>
				<Select
					containerClass="select-facility"
					name="facility"
					placeholder="Select..."
					className="request-shifts-modal-select"
					isSearchable
					options={facilities}
					value={selectedFacility?.id}
					handleChange={handleSelectFacility}
					filterFn={facilityNameFilter}
				/>
			</div>
		</div>
	</div>
);

const RequestNewShiftsTab = ({
	isOnCall,
	isGlobalCalendar,
	isFlex,
	isHybrid,
	facilities,
	selectedFacility,
	handleSelectFacility,
	currentShiftStructures,
	shiftsGroups,
	updateShift,
	removeShift,
	addEmptyShiftGroup,
	errors,
	showUnits,
	currentFacilityUnits,
	maxShiftsToCreate,
	checkIfCanAddTodayShiftForStructure,
	isMobile
}) => (
	<>
		{isOnCall && <OnCallInfoBanner />}
		{isGlobalCalendar && (
			<GlobalCalendarFacilitySelector
				facilities={facilities}
				selectedFacility={selectedFacility}
				handleSelectFacility={handleSelectFacility}
			/>
		)}
		<ShiftsForm
			infoText={SECTION_INFO_TEXT}
			shiftsGroups={shiftsGroups}
			updateShift={updateShift}
			removeShift={removeShift}
			addEmptyShiftGroup={addEmptyShiftGroup}
			errors={errors}
			currentShiftStructures={currentShiftStructures}
			isFlex={isFlex}
			isHybrid={isHybrid}
			isGlobalCalendar={isGlobalCalendar}
			selectedFacility={selectedFacility}
			showUnits={showUnits}
			currentFacilityUnits={currentFacilityUnits}
			maxShiftsToCreate={maxShiftsToCreate}
			checkIfCanAddTodayShiftForStructure={checkIfCanAddTodayShiftForStructure}
			isMobile={isMobile}
		/>
	</>
);

export default RequestNewShiftsTab;
